import React, { useState } from 'react';
import './messagingschedule.css';

const MessagingSchedule = () => {
  const [messages, setMessages] = useState([...Array(10)].map((_, index) => ({
    id: `JN-${index + 1}`,
    title: `Message ${index + 1}`,
    image: '/talent-images/talent-1.jpg',
    status: 'GLOBAL',
    isLive: index < 5, // First 5 are live, rest are disabled
    isGlobal: true
  })));

  const toggleGlobal = (messageId) => {
    setMessages(messages.map(msg => {
      if (msg.id === messageId) {
        const newIsGlobal = !msg.isGlobal;
        return {
          ...msg,
          isGlobal: newIsGlobal,
          status: newIsGlobal ? 'GLOBAL' : 'LOCAL'
        };
      }
      return msg;
    }));
  };

  const handleDisable = (messageId) => {
    setMessages(messages.map(msg => 
      msg.id === messageId ? { ...msg, isLive: false } : msg
    ));
  };

  const handleGoLive = (messageId) => {
    setMessages(messages.map(msg => 
      msg.id === messageId ? { ...msg, isLive: true } : msg
    ));
  };

  return (
    <>
      <h1>Messaging Schedule</h1>
      <p className="schedule-subtitle">
        Below, you can choose which messages are Live or Disabled.
      </p>
      <div className="messages-section">
        <div className="messages-group">
          <div className="section-header">
            <span className="volume-icon">🔊</span>
            <h2>Live Messages</h2>
          </div>
          <div className="messages-grid">
            {messages.filter(msg => msg.isLive).map((message, index) => (
              <div key={message.id} className="message-card-area">
                <div className="message-schedule-page-card">
                  <img src={message.image} alt={message.title} className="talent-image" />
                  <div className="play-overlay">
                    <button className="play-icon"></button>
                    <button 
                      className="disable-icon"
                      onClick={(e) => {
                        e.stopPropagation();
                        handleDisable(message.id);
                      }}
                    >
                      Disable
                    </button>
                  </div>
                  <div className="message-id">{message.title}</div>
                  <div className="status-label">
                    <span className={`status-text ${!message.isGlobal ? 'active' : ''}`}>Local</span>
                    <label className="status-switch">
                      <input 
                        type="checkbox" 
                        checked={message.isGlobal}
                        onChange={() => toggleGlobal(message.id)}
                        onClick={(e) => e.stopPropagation()}
                      />
                      <span className="status-slider"></span>
                    </label>
                    <span className={`status-text ${message.isGlobal ? 'active' : ''}`}>Global</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="messages-group">
          <div className="section-header">
            <span className="volume-icon muted">🔇</span>
            <h2>Disabled Messages</h2>
          </div>
          <div className="messages-grid">
            {messages.filter(msg => !msg.isLive).map((message, index) => (
              <div key={message.id} className="message-card-area">
                <div className="message-schedule-page-card">
                  <img src={message.image} alt={message.title} className="talent-image" />
                  <div className="play-overlay">
                    <button className="play-icon"></button>
                    <button 
                      className="disable-icon"
                      onClick={(e) => {
                        e.stopPropagation();
                        handleGoLive(message.id);
                      }}
                    >
                      Go Live
                    </button>
                  </div>
                  <div className="message-id">{message.title}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default MessagingSchedule; 